export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/deleteExamForm`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allExamFormsByAgents']

    })
